<div class="detail-panel">
  <div class="flex justify-end items-center">
    <button (click)="close()" class="button button-primary button-sm" title="Cerrar detalles">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>
  
  <h2 class="text-primary-500">{{ criteria?.name }}</h2>

  <ul>
    <li>
      <strong>ID:</strong> {{ criteria?.id }}
    </li>
    <li>
      <strong>Descripción:</strong><br>
      {{ criteria?.description }}
    </li>
    <li>
      <strong>Estado:</strong> {{ criteria?.disabled ? 'Deshabilitado' : 'Habilitado' }}
    </li>
  </ul>

  <div class="flex justify-center mt-6 space-x-4">
    <button (click)="close()" class="button button-outlined-primary">Cancelar</button>
    <a [routerLink]="['/acceptance-criteria/update', criteria?.id]" class="button button-primary">Editar</a>
  </div>
</div>
  